<template>
  <div class="Site IndexBox">
    <div class="ScrollBox">
      <van-swipe :autoplay="3000" indicator-color="#888" style="height: 10rem">
        <van-swipe-item v-for="(item,index) in InitData.bannerList" :key="index">
          <img :src="item" width="100%">
        </van-swipe-item>
      </van-swipe>
      <van-tabs :ellipsis="false" :border="false" color="#4087f1" title-active-color="#4087f1" background="#fff" title-inactive-color="#333" line-width="60" v-model="tabsIndex" @change="changeTabs">
        <van-tab v-for="item in InitData.taskclasslist.filter(obj=>obj.state==1)" :title="item.group_name" :key="item.group_id" style="padding: 0 12px;">
          <van-cell v-for="item in InitData.UserGradeList" :key="item.grade" @click="openTaskList(item.grade,item.name,item.state)">
            <template #title>
              <b>{{item.name}}</b>
			  <div v-if="item.state==1" v-html="$t('vip.list.label',{number: item.number})"></div>
              <div v-if="item.state==3">Stay tuned</div>
            </template>
            <span class="tag" v-if="UserInfo.vip_level==item.grade">{{$t('task.index[0]')}}</span>
          </van-cell>
        </van-tab>
      </van-tabs>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'Task',
  components: {
  },
  props: ['tabsActive'],
  data() {
    return {
      taskType: '',
      tabsIndex: 0,
      isStore: false,
    }
  },
  computed: {
  },
  watch: {

  },
  created() {
    this.tabsIndex = this.tabsActive?Number(this.tabsActive):0
    if(this.InitData.taskclasslist.length){
      this.taskType = this.InitData.taskclasslist.filter(obj=>obj.state==1)[0].group_id
      if(this.tabsActive){
        this.taskType = this.InitData.taskclasslist.filter(obj=>obj.state==1)[this.tabsActive].group_id
      }
    }
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    changeTabs(index) {
      this.taskType = this.InitData.taskclasslist.filter(obj=>obj.state==1)[index].group_id
    },
    openTaskList(grade,name,state) {
      if(this.UserInfo.vip_level<grade){
        const html = this.$t('task.index[1]',{currVip: this.UserInfo.useridentity,vip:name})
        /*this.$Dialog.Confirm(html,()=>{
          this.$router.push('/vip')
        }, this.$t('task.index[2]'))*/
		if (state == 1)
		{
			this.$dialog.confirm({
					 message: html,
					 confirmButtonText: this.$t('task.index[2]'), //改变确认按钮上显示的文字
					 cancelButtonText: this.$t('task.index[4]') //改变取消按钮上显示的文字
			}).then(()=> {
					this.$router.push('/vip')
			}).catch(() => {
					
			})
		}
 		
      }else{
        if(this.taskType){
          this.$router.push(`/taskList/${this.taskType}/${grade}`)
        }else{
          this.$Dialog.Toast(this.$t('task.index[3]'))
        }
      }
    },
  }
}
</script>
<style scoped>
.van-tab__pane{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.van-cell{
  background-size: contain;
  box-shadow: 0 1px 2px rgba(0,0,0,.2);
  border-radius: 5px;
  padding: 20px 15px;
  margin-top: 8px;
  width: calc(100vw/2 - 18px);
}
.ScrollBox ::v-deep .van-tabs__line {
  bottom: 25px;
}
.van-cell .van-cell__title{
  flex: auto;
  color: #fff;
  text-align: center;
  font-size: 14px;
}
.van-cell .van-cell__title b{
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 10px;
}
.van-cell .van-cell__value{
  position: absolute;
  top: 10px;
  left: 0;
  background-color: rgba(0, 0, 0, .2);
  color: #fff;
  font-size: 12px;
  padding: 0 8px 0 5px;
  border-radius: 0 50px 50px 0;
}
</style>